import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-update-check',
  templateUrl: './update-check.component.html',
  styleUrls: ['./update-check.component.scss'],
})
export class UpdateCheckComponent implements OnInit,OnChanges {

  showInstallCard:boolean;
  isWeb:any;
  isMacOs:any;
  isWindowsOs:any;
  isCancel:string = localStorage.getItem('isCancelInstall');  
  constructor( private platform: Platform) {
    this.showInstallCard = true;
    const isWeb = localStorage.getItem('isWeb');
    const isCancelInstall = localStorage.getItem('isCancelInstall');
    const isMobileWeb = localStorage.getItem('isMobileWeb');
    const isNative = localStorage.getItem('isNative');
    this.isMacOs = window.navigator.userAgent.toLowerCase().includes('mac');
    this.isWindowsOs = window.navigator.userAgent.toLowerCase().includes('windows') || window.navigator.userAgent.toLowerCase().includes('android');
    // alert('isWEB--'+ localStorage.getItem('isWeb') +'| isCancel-'+localStorage.getItem('isCancelInstall'));
    if((isWeb === 'true' || isMobileWeb === 'true' || isNative === 'false') && isCancelInstall === 'false'){
      this.showInstallCard = true;
    } else {
      this.showInstallCard = false;
    }
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  cancelInstall(){
    this.showInstallCard = false;
    localStorage.setItem('isCancelInstall','true');
  }

}
